const getDefaultState = () => {
  return {
    sale_state: 0,
    sale_package: {
      id: null,
      type: null,
      duration: null,
      price: null,
      period: null,
      session_max: null,
    },
    sale_member: null,
    sale_payment: {
      price: null,
      qty: null,
      session: null,
      duration: null,
      duration_unit: null,
      activate_date: null,
      discount: null,
      discount_unit: null,
      total: null,
      paidby: null,
      note: null,
      sale_date: null
    },
    sale_qrcode:{
      member_phone:null,
      member_email:null,
    },
    sale_employee: null
  };
};

const state = getDefaultState();

const getters = {
  getSalePackage: (state) => {
    return state.sale_package;
  },
  getSaleState: (state) => {
    return state.sale_state;
  },
  getSaleMember: (state) => {
    return state.sale_member;
  },
  getSalePayment: (state) => {
    return state.sale_payment;
  },
  getSaleQrcode: (state) => {
    return state.sale_qrcode;
  },
  getSaleEmployee: (state) => {
    return state.sale_employee;
  },
};

const mutations = {
  setSaleState(state, payload) {
    state.sale_state = payload;
  },
  setSalePackage(state, payload) {
    state.sale_package = payload;
  },
  setSaleMember: (state, payload) => {
    state.sale_member = payload;
  },
  setSaleEmployee: (state, payload) => {
    state.sale_employee = payload;
  },
  setSalePayment: (state, payload) => {
    state.sale_payment = payload;
  },
  setSaleQrcode: (state, payload) => {
    state.sale_qrcode = payload;
  },
  resetSale: (state) => {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  setSaleState({
    commit
  }, payload) {
    commit("setSaleState", payload);
  },
  setSalePackage({
    commit
  }, payload) {
    commit("setSalePackage", payload);
    //localStorage.setItem("sale_package", JSON.stringify(payload));
  },
  setSaleMember({
    commit
  }, payload) {
    commit("setSaleMember", payload);
  },
  setSaleEmployee({
    commit
  }, payload) {
    commit("setSaleEmployee", payload);
  },
  setSalePayment({
    commit
  }, payload) {
    commit("setSalePayment", payload);
  },
  setSaleQrcode({
    commit
  }, payload) {
    commit("setSaleQrcode", payload);
  },
  resetSale({
    commit
  }) {
    commit("resetSale");
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};